import { IVector3 } from './gameplay';

export const handlingProperties = [
	// 'handlingName',                    // null
	'fMass', // 0 - 15000
	// 'fDownforceModifier'               // null
	'fInitialDragCoeff', // 10 - 120
	'vecCentreOfMassOffset', // -2 - 2
	'vecInertiaMultiplier', // -2 - 2
	// 'vecSeatOffsetDist',               // -2 - 2
	'fPercentSubmerged', // 0 - 100
	// 'fSubmergedRatio',                 // null
	'fDriveBiasFront', // 0 - 1
	// 'fDriveBiasRear',                  // Сами считаем
	'nInitialDriveGears', // 1 - 6
	'fDriveInertia', // 0 - 2.5
	'fClutchChangeRateScaleUpShift', // 0 - 10
	'fClutchChangeRateScaleDownShift', // 0 - 3
	'fInitialDriveForce', // 0 - 25
	// 'fDriveMaxFlatVel',                // Не используется
	// 'fInitialDriveMaxFlatVel',         // Не используется (Заглушка)
	'fBrakeForce', // 0.1 - 1
	'fBrakeBiasFront', // 0 - 1
	// 'fBrakeBiasRear',                  // Сами считаем
	'fHandBrakeForce', // 0 - 1
	'fSteeringLock', // 1 - 90
	// 'fSteeringLockRatio',              // Сами считаем
	'fTractionCurveMax', // 0 - 3
	// 'fTractionCurveMaxRatio',          // Сами считаем
	'fTractionCurveMin', // 0 - 3
	// 'fTractionCurveMinRatio',          // Сами считаем
	// 'fTractionCurveRatio',             // null
	'fTractionCurveLateral', // 10 - 30
	// 'fTractionCurveLateralRatio',      // Сами считаем
	'fTractionSpringDeltaMax', // 0 - 0.5
	// 'fTractionSpringDeltaMaxRatio',    // Сами считаем
	'fLowSpeedTractionLossMult', // 0 - 2
	// 'fCamberStiffness',                // 0 - 90
	'fTractionBiasFront', // 0 - 1
	// 'fTractionBiasRear',               // Сами считаем
	'fTractionLossMult', // 0 - 1
	'fSuspensionForce', // 0 - 5
	'fSuspensionCompDamp', // 0 - 3
	'fSuspensionReboundDamp', // 0 - 3
	'fSuspensionUpperLimit', // 0 - 1
	'fSuspensionLowerLimit', // -1 - 0
	'fSuspensionRaise', // 0 - 1
	'fSuspensionBiasFront', // 0 - 1
	// 'fSuspensionBiasRear',             // Сами считаем
	'fAntiRollBarForce', // 0 - 2
	'fAntiRollBarBiasFront', // 0 - 1
	// 'fAntiRollBarBiasRear',            // Сами считаем
	'fRollCentreHeightFront', // 0 - 1
	'fRollCentreHeightRear', // 0 - 1
	'fCollisionDamageMult', // 0 - 10
	'fWeaponDamageMult', // 0 - 10
	'fDeformationDamageMult', // 0 - 10
	'fEngineDamageMult', // 0 - 10
	'fPetrolTankVolume', // 0 - 250
	'fOilVolume', // 0 - 10
	'nMonetaryValue', // 0 - 1000
	'strModelFlags', // https://gtamods.com/wiki/Handling.meta
	'strHandlingFlags', // https://gtamods.com/wiki/Handling.meta
	// 'strDamageFlags',                  // Не используется https://gtamods.com/wiki/Handling.meta
	// 'AIHandling',                      // Не используется

	// SubHandling
	// 'fBackEndPopUpCarImpulseMult',
	// 'fBackEndPopUpBuildingImpulseMult',
	// 'fBackEndPopUpMaxDeltaSpeed',
	// 'fToeFront',
	// 'fToeRear',
	// 'fCamberFront',
	// 'fCamberRear',
	// 'fCastor',                         // не работает
	// 'fEngineResistance',
	// 'fMaxDriveBiasTransfer',
	// 'fJumpForceScale',
	// 'fIncreasedRammingForceScale',     // null
	'strAdvancedFlags', // https://gtamods.com/wiki/Handling.meta
	// 'strFlags',                        // null
] as const;

export enum HandlingMode {
	Comfort = 'comfort',
	Drift = 'drift',
	Sport = 'sport',
}

export enum HandlingModeName {
	Comfort = 'COMFORT',
	Drift = 'DRIFT',
	Sport = 'SPORT',
}

export type HandlingValue = number | string | IVector3 | null;
export type VehicleHandling = Partial<Record<string, HandlingValue>>;

export type VehicleHandlingWithModes = Partial<{
	[key in HandlingMode]: VehicleHandling;
}>;

const transformKey = (key: string): string => {
	return key
		.replace(/Min/g, 'MIN')
		.replace(/Max/g, 'MAX')
		.replace(/[^A-Z]+/g, '');
};

const reverseMap: Record<string, string> = {};
handlingProperties.forEach((property) => {
	reverseMap[transformKey(property)] = property;
});

export function clampHandling(handling: VehicleHandling) {
	Object.entries(handling).forEach(([prop, value]) => {
		if (typeof value === 'number') {
			handling[prop] = Math.round(value * 1000) / 1000;
		}
	});
}

export function serializeHandling(deserialized: VehicleHandling): VehicleHandling {
	const serialized: VehicleHandling = {};

	handlingProperties.forEach((property) => {
		if (Object.prototype.hasOwnProperty.call(deserialized, property)) {
			const newKey = transformKey(property);
			serialized[newKey] = deserialized[property];
		}
	});

	clampHandling(serialized);

	return serialized;
}

export function deserializeHandling(serialized: VehicleHandling): VehicleHandling {
	const deserialized: VehicleHandling = {};

	for (const key in serialized) {
		if (Object.prototype.hasOwnProperty.call(serialized, key)) {
			const originalKey = reverseMap[key];
			if (originalKey) {
				deserialized[originalKey] = serialized[key];
			}
		}
	}

	clampHandling(deserialized);

	return deserialized;
}

export function serializeHandlingWithModes(handling: VehicleHandlingWithModes): VehicleHandlingWithModes {
	const serialized: VehicleHandlingWithModes = {};

	if (handling) {
		Object.entries(handling).forEach(([mode, handling]) => {
			serialized[mode as HandlingMode] = serializeHandling(handling);
		});
	}

	return serialized;
}

export function deserializeHandlingWithModes(handling: VehicleHandlingWithModes): VehicleHandlingWithModes {
	const deserialized: VehicleHandlingWithModes = {};

	if (handling) {
		Object.entries(handling).forEach(([mode, handling]) => {
			deserialized[mode as HandlingMode] = deserializeHandling(handling);
		});
	}

	return deserialized;
}
